import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { CondicaoPagamentoSelectComponent } from './condicao-pagamento-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CondicaoPagamentoSelectComponent
    ],
    exports: [
        CondicaoPagamentoSelectComponent
    ]
})
export class CondicaoPagamentoSelectModule { }
